import {
  user_update_mobile_number_save_path,
  user_update_mobile_number_confirm_path,
  user_management_resend_confirmation_path,
  user_management_resend_invitation_path,
  user_management_cancel_invitation_path,
  companion_qr_svg_path
} from '~/routes'

export const User = {
	DATA_FIELD_ENUM: function () {
		return {
			lastname: 0,
			firstname: 1,
			email: 2,
			role: 3,
			application: 4,
			project: 5,
			login: 6,
			action: 7,
			person: 8,
			call: 9,
			phase: 10
		}
	},
	
	update_mobile_number: function () {
		jQuery('#update-mobile-number-save').on('click', function () {
			jQuery.ajax({
				url: user_update_mobile_number_save_path(),
				method: 'post',
				data: { mobile_number: jQuery('#mobile_number').val() }
			}).done(function (data) {
				if (data.status == 'ok') {
					jQuery('#mobile-confirmation-modal').trigger('click'); // open dialog
				}
				else {
					jQuery('#errors').html('');
					var $ul = jQuery('<ul>').addClass('alert alert-danger list-unstyled form-errors');
					Object.keys(data.errors).forEach((k) => {
						data.errors[k].forEach((err) => {
							var $li = jQuery('<li>').html(err.message);
							$li.data('highlight-selector', err.highlight_selector);
							$ul.append($li);
					    })
					});
					jQuery('#errors').append($ul);
				}
			});
			return false;
		});

		jQuery(document).on('sms:opened', function(e, type, identifier) {
        jQuery('.concept-note-form input[name="concept_note[confirmation_code]"]').val(identifier);
    })

    jQuery(document).on('sms:success', function(e, type, identifier){
        if (type == 'mobile_number_confirmation') {
        	Turbo.visit(user_update_mobile_number_confirm_path({identifier: identifier}));
        }
    });
    jQuery(document).on('sms:failed', function(e, type, identifier){
    });
  },
  
  list_programmes: function() {
    // Has the same background image layout.
    ActionJS.Login._initLoginLayout();
  },

  activation_message: function(){
    ActionJS.Login._initLoginLayout();
  },

  confirm_activation: function(){
    ActionJS.Login._initLoginLayout();
  },

  confirm_email: function(){
	ActionJS.Login._initLoginLayout();

	var keys = [8, 9, 16, 17, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 145]

	// Pasting into authentication code fields
	$(document).on("paste", function(e) {
		if ($(e.target).hasClass('auth-code') && !$(e.target).is(':disabled')) {
			const data = e.originalEvent.clipboardData.getData('Text');
			const chars = data.split('');
		
			const inputs = $('.auth-code:enabled').slice($('.auth-code:enabled').index($(e.target)));
		
			inputs.each(function(index) {
				if (index < chars.length) {
					$(this).val(chars[index]);
				} else {
					return false;
				}
			});
		
			if (chars.length > 0) {
				const lastInputIndex = Math.min(chars.length, inputs.length) - 1;
				inputs.eq(lastInputIndex).focus();
			}
		}
	});

	$(".auth-code").keydown(function(e) {
        if (e.which == 8 && this.value.length == 0) {
			if ($(this).prev('input').is(':disabled') ) {
				$(this).prev('input').prev('input').focus();
			} else {
				$(this).prev('input').focus();
			}
		}
    }).keyup (function (e) {
		if (this.value.length > 1) {
			var element = this;
			setTimeout(function () {
				var splitted = $(element).val().split("");
				var index = parseInt(element.id.split("-")[1], 10);
				splitted.forEach(function(i){
					if (i != "-" && i != " ") {
						$("#digit-" + index.toString()).val(i);
						index += 1;
					}
					$("#digit-" + index.toString()).focus();
				})
			}, 50);
		}
		if (this.value.length = 1 && !(keys.includes(e.which))) {
			if ($(this).next('input').is(':disabled') ) {
				$(this).next('input').next('input').focus();
			} else {
				$(this).next('input').focus();
			}
			return false;
        }
	});
  },

  verify_email: function(){
	ActionJS.Login._initLoginLayout();

	var keys = [8, 9, 16, 17, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 145]

	$(".auth-code").keydown(function(e) {
        if (e.which == 8 && this.value.length == 0) {
			if ($(this).prev('input').is(':disabled') ) {
				$(this).prev('input').prev('input').focus();
			} else {
				$(this).prev('input').focus();
			}
		}
    }).keyup (function (e) {
		if (this.value.length > 1) {
			var element = this;
			setTimeout(function () {
				var splitted = $(element).val().split("");
				var index = parseInt(element.id.split("-")[1], 10);
				splitted.forEach(function(i){
					if (i != "-" && i != " ") {
						$("#digit-" + index.toString()).val(i);
						index += 1;
					}
					$("#digit-" + index.toString()).focus();
				})
			}, 50);
		}
		if (this.value.length = 1 && !(keys.includes(e.which))) {
			if ($(this).next('input').is(':disabled') ) {
				$(this).next('input').next('input').focus();
			} else {
				$(this).next('input').focus();
			}
			return false;
        }
	});
  },

  account_activation: function(){
    ActionJS.Login._initLoginLayout();
  },

  // skipCatpcha only skips the frontend execution. Returns a captcha check error if called in environment where captcha is enabled.
	new_alt: function(skipCaptcha = false) {
	this.new(skipCaptcha);

	document.removeEventListener('click', window._switchLoginHandler);
	window._switchLoginHandler = e => {
		const t = e.target.closest('.switch-login-view');
		if (!t) return;
		e.preventDefault();
		const root = t.closest('.registration-alt') || document;
		const wrap = root.querySelector('.form-wrap');
		const current = root.querySelector('.visible');
		const next = current.classList.contains('login-form-alt')
		? root.querySelector('.register-form-alt')
		: root.querySelector('.login-form-alt');
		if (!wrap || !current || !next) return;

		wrap.style.height = current.offsetHeight + 'px';
		next.classList.add('visible');
		next.style.opacity = '0';
		void next.offsetHeight;
		wrap.style.height = next.offsetHeight + 'px';

		const view = next.classList.contains('login-form-alt') ? 'login' : 'register';
		const url = new URL(location.href);
		url.searchParams.set('view', view);
		history.replaceState(null, '', url);
		root.classList.toggle('register-view', view === 'register');
		root.classList.toggle('login-view', view === 'login');

		requestAnimationFrame(() => {
			next.style.opacity = '';
			current.classList.remove('visible');
		});
	};
	document.addEventListener('click', window._switchLoginHandler, { passive: false });

	window.addEventListener('load', () => {
			const wrap = document.querySelector('.form-wrap');
			const vis = document.querySelector('.form-wrap .visible');
			if (wrap && vis) wrap.style.height = vis.offsetHeight + 'px';
		});
	},

  new: function(skipCaptcha = false){
    ActionJS.Login._initLoginLayout();
    
    const emailField = $('#user_email_address');
    const emailConfirmField = $('#user_email_address_confirmation');
    const passwordField = $('#user_password');
    const passwordConfirmField = $('#user_password_confirmation');

    const fieldsMatch = (field, confirmField) => field.val() === confirmField.val() || !confirmField.val();
    const validatePassword = (password) => password.length >= 14;

    const setVisible = (warningLabelId, visible) => {
      const warning = $(`#${warningLabelId}`);
      if (!visible) {
        warning.removeClass('hidden');
      } else {
        warning.addClass('hidden');
      }
    };

    const validateForm = () => {
      const isEmailMatch = fieldsMatch(emailField, emailConfirmField);
      const isPasswordMatch = fieldsMatch(passwordField, passwordConfirmField)
      const isPasswordValid = validatePassword(passwordField.val()) || !passwordField.val();

      setVisible('email_confirm_warning', isEmailMatch);
      setVisible('password_confirm_warning', isPasswordMatch);
      setVisible('password_warning', isPasswordValid);
    };

    emailField
      .add(emailConfirmField)
      .add(passwordField)
      .add(passwordConfirmField)
      .on('input', validateForm);
	
    // $('#submit-btn').on('click', (e) => {
    //   if (!skipCaptcha) {
    //     e.preventDefault();
    //     grecaptcha.execute();
    //   }
    // });
  },

  registration: function(){
    ActionJS.Login._initLoginLayout();
  },

  confirm_registration: function(){
    ActionJS.Login._initLoginLayout();
  },


	management_list: function () {
		jQuery('[data-tooltip="true"]').tooltip();

		// var tableData = JSON.parse(jQuery('#user-data').html());
		// // Adding new empty field for select column
		// tableData.forEach(function(element) {
		// 	element.unshift('');
		// });
		// // Change the column indices
		// var colEnum = this.DATA_FIELD_ENUM();
		// jQuery.each(colEnum, function (key, value) {
		// 	colEnum[key] = value + 1;
		// });
		// colEnum.select = 0;
		// var options = {
		// 	bDeferRender: true,
		// 	aaData: tableData,
		// 	info: false,
		// 	lengthChange: false,
		// 	pageLength: 20,
		// 	autoWidth: false,
		// 	stateSave: true,
		// 	order: [[colEnum.lastname, "asc"]],
		// 	"fnCreatedRow": function (nRow, aData, iDataIndex) {
		// 		jQuery(nRow).attr('class', 'user-row-' + aData[colEnum.person].id);
		// 	},
		// 	select: {
		// 		style: 'multi',
		// 		selector: 'td:first-child'
		// 	},
		// 	aoColumnDefs: [
		// 		{
		// 			aTargets: colEnum.select,
		// 			searchable: false,
		// 			sortable: false,
		// 			className: 'select-checkbox',
		// 		},
		// 		{
		// 			aTargets: [colEnum.lastname, colEnum.firstname, colEnum.role],
		// 			mRender: function (data, type, rowData) {
		// 				return data;
		// 			},
      //
		// 		},
		// 		{
		// 			aTargets: [colEnum.action],
		// 			searchable: false,
		// 			sortable: false,
      //
		// 		},
		// 		{
		// 			mRender: function (data, type, rowData) {
		// 				var display = '';
		// 				if (data.size > 0) {
		// 					if (data.first[1]) {
		// 						display = data.first[1];
		// 					} else {
		// 						display = I18n.t('no_project_id_tag');
		// 					}
		// 				}
		// 				if (type == 'display') {
		// 					var projectKeys = [];
		// 					if (data.size > 0) {
		// 						if (data.type == 'project') {
		// 							var projects = data.projects;
		// 							var link = '#project-link-template';
		// 						} else {
		// 							var projects = data.applications;
		// 							var link = '#application-link-template';
		// 						}
      //
		// 						projectKeys = Object.keys(projects).sort(function (a, b) {
		// 							if (projects[a] && !projects[b]) return -1;
		// 							if (!projects[a] && projects[b]) return 1;
		// 							return 0;
		// 						});
      //
		// 						var projectId = (projects[projectKeys[0]] ? projects[projectKeys[0]] : I18n.t('no_project_id_tag'))
		// 						var id = projectKeys[0];
      //
		// 						display = jQuery(link).html().
		// 							replace(/___project_id___/g, projectId).
		// 							replace(/___note_id___/g, id);
		// 					}
      //
		// 					if (data.size > 1) {
		// 						if (data.type == 'project') {
		// 							var projects = data.projects;
		// 							var template = 'projects-list-template';
		// 							var link = '#project-list-item-template';
		// 						} else {
		// 							var projects = data.applications;
		// 							var template = 'applications-list-template';
		// 							var link = '#application-list-item-template';
		// 						}
      //
		// 						var listId = template + '-' + data.person_id;
		// 						jQuery('#' + template).clone().attr('id', listId).appendTo('.main.clearfix');
      //
		// 						projectKeys.forEach(function (a, i, array) {
		// 							if (i > 0) {
		// 								var projectId = (projects[a] ? projects[a] : I18n.t('no_project_id_tag'));
		// 								var item = jQuery(link).html().
		// 									replace(/___project_id___/g, projectId).
		// 									replace(/___note_id___/g, a)
      //
		// 								var list = jQuery('#' + listId).html().replace(/___list_item___/g, item + '___list_item___');
		// 								jQuery('#' + listId).html(list);
      //
		// 								if (i < array.length - 1) {
		// 									var separator = jQuery('#list-separator-template').html();
		// 									list = jQuery('#' + listId).html().replace(/___list_item___/g, separator + '___list_item___');
		// 									jQuery('#' + listId).html(list);
		// 								}
		// 							}
		// 						});
      //
		// 						var list = jQuery('#' + listId).html().replace(/___list_item___/g, '');
		// 						jQuery('#' + listId).html(list);
      //
		// 						display += jQuery('#' + listId).html();
		// 					}
		// 				} else {
		// 					if (data.size > 1) {
		// 						projects = (data.type == 'project' ? data.projects : data.applications)
      //
		// 						Object.keys(projects).map(function (a) {
		// 							var projectId = (projects[a] ? projects[a] : I18n.t('no_project_id_tag'));
		// 							display += (' ' + projectId);
		// 						});
		// 					}
		// 				}
		// 				return display;
		// 			},
		// 			aTargets: [colEnum.project, colEnum.application],
		// 			defaultContent: ''
		// 		},
		// 		{
		// 			mRender: function (data, type, rowData) {
		// 				if (data.confirmed == "1") {
		// 					return "<i class='fa fa-circle mr-1' style='color: #7eae71;'></i>" + data.email;
		// 					// return data.email + "<i class='fa fa-circle ml-1' style='color: #7eae71;'></i>"
		// 				} else {
		// 					return  "<i class='fa fa-circle mr-1' style='color: #cccccc;'></i>" + data.email;
		// 					// return data.email + "<i class='fa fa-circle ml-1' style='color: #cccccc;'></i>"
		// 				}
		// 				return data.email
		// 			},
		// 			aTargets: [colEnum.email],
		// 			defaultContent: ''
		// 		},
		// 		{
		// 			aTargets: [colEnum.person],
		// 			visible: false,
		// 		},
		// 		{
		// 			mRender: function (data, type, rowData) {
		// 				if (type == 'filter') {
		// 					return data.calls;
		// 				}
		// 			},
		// 			aTargets: [colEnum.call],
		// 			visible: false,
		// 			defaultContent: ''
		// 		},
		// 		{
		// 			mRender: function (data, type, rowData) {
		// 				if (type == 'filter') {
		// 					return data.phases;
		// 				}
		// 			},
		// 			aTargets: [colEnum.phase],
		// 			visible: false,
		// 			defaultContent: ''
		// 		},
		// 		{
		// 			mRender: function (data, type, rowData) {
		// 				if (type == 'display') {
		// 					return data.label;
		// 				}
		// 				return data.sort;
		// 			},
		// 			aTargets: [colEnum.login]
		// 		}
		// 	],
      // footerCallback: function () {
      //   DataTablesHelper.togglePagination(this);
      //
	  //   if ($('th.select-checkbox').hasClass('selected'))
		//   this.api().rows().select();
      // },
		// 	initComplete: function() {
      //   DataTablesHelper.addColumnFilters(this);
      // }
      //
		// };
		// var userTable = jQuery('#user-table');
		// if (!$.fn.DataTable.isDataTable('#user-table')){
		// 	var table = userTable.DataTable(options);
		// }
      //
		// table.on('select deselect', function ( e, dt, type ) {
		// 	// table[ type ]( indexes ).nodes().to$().addClass( 'custom-selected' );
		// 	var sel = table.rows({ selected: true }).data().length;
		// 	if (sel > 0){
		// 		jQuery('#send-email-btn .selected_count').text("(" + sel +  ")");
		// 		jQuery('#send-email-btn').addClass("selections-available")
		// 		jQuery('#bulk-delete-btn').attr('disabled', false)
		// 	}
		// 	else{
		// 		jQuery('#send-email-btn .selected_count').text("");
		// 		jQuery('#send-email-btn').removeClass("selections-available")
		// 		jQuery('#bulk-delete-btn').attr('disabled', true)
		// 	}
      //
		// 	jQuery('[data-react-class-value="DeleteUsersInBulkLink"]').attr('data-person_ids', getSelectedIds());
		// } );
      //
		// table.on('click', 'th.select-checkbox', function() {
		// 	if ($(this).hasClass('selected')) {
		// 		table.rows().deselect();
		// 		$(this).removeClass('selected');
		// 	} else {
		// 		table.rows().select();
		// 		$(this).addClass('selected');
		// 	}
		// }).on('select deselect', function() {
		// 	if (table.rows({
		// 		selected: true
		// 	}).count() !== table.rows().count()) {
		// 		$(this).removeClass('selected');
		// 	} else {
		// 		$(this).addClass('selected');
		// 	}
		// });

		// function getSelectedIds() {
		// 	var ids = [];
		// 	table.rows({ selected: true }).data().each(function (e) {
		// 		ids.push(e[colEnum.person].person_id);
		// 	})
		// 	jQuery('#selected-users').html(JSON.stringify(ids));
		// 	return JSON.stringify(ids);
		// }

        ActionJS.User.selectedUserIds = [];

		jQuery('#send-email-btn').on('click', function (event) {
			event.preventDefault();
			jQuery('#modal-dialog').on('modal:loaded', function () {
				jQuery('.recipient-count').html(jQuery('.send-email-list input:checked').length);
			});
			openModalDialog({
				title: I18n.t('send_email'),
				saveLabel: I18n.t('send_email'),
				url: jQuery(this).attr('href'),
				method: 'POST',
				requestBody: {ids: JSON.stringify(ActionJS.User.selectedUserIds)}
			});
		});

		// jQuery.fn.dataTable.ext.search.push(
		// 	function (settings, data, dataIndex) {
		// 		var callId = jQuery('select#get_call_id').val();
		// 		var phaseId = jQuery('select#get_phase_id').val();
		// 		var callFilter = true;
		// 		var phaseFilter = true;
        //
		// 		if (callId) {
		// 			var calls = data[colEnum.call].split(',');
		// 			callFilter = calls.indexOf(callId) != -1
		// 		}
        //
		// 		if (phaseId) {
		// 			var phases = data[colEnum.phase].split(',');
		// 			phaseFilter = phases.indexOf(phaseId) != -1
		// 		}
        //
		// 		return callFilter && phaseFilter;
		// 	}
		// );

		jQuery('select#datagridCallFilterInput').on('change', function (event) {
			const phaseDropdown = jQuery('select#datagridPhaseFilterInput');
			phaseDropdown.val(phaseDropdown.find('option:first').val()).trigger('change');

			const callId = jQuery(this).val();
			if (callId) {
				phaseDropdown.find('option').not(`[data-call-id="${callId}"]`).not('[value=""]').prop('disabled', true);
				phaseDropdown.find(`[data-call-id="${callId}"]`).prop('disabled', false);
			} else {
				phaseDropdown.find('option').prop('disabled', false);
			}
			phaseDropdown.trigger('change.select2');
		});

		// jQuery('select#datagridPhaseFilterInput').on('change', function (event) {
			// var table = jQuery('#user-table').DataTable();
			// table.draw();
			// var phaseId = jQuery('select#datagridPhaseFilterInput').val();
		// });

        jQuery(document).on('click', '.resend-confirmation', function () {
			var link = jQuery(this);
			jQuery.ajax({
				url: user_management_resend_confirmation_path({
					person_id: link.data('person-id'),
					project_id: link.data('project-id')
				}),
				method: 'post'
			}).done(function (data) {
				link.closest('li').html('<span class="text-disabled">' + I18n.t('confirmation_sent') + '</span>');
			});

			e.preventDefault();
			return false;
		});
	},

	management_new: function () {
		jQuery('#set-new-password').on('click', function () {
			var div = jQuery(this).next()
			div.toggleClass('hidden');

			div.find('input').removeAttr('disabled');
			jQuery(this).remove();
		})
	},

	programme_list: function () {
		jQuery('.invitation-resend-link').on('click', function () {
			var $link = jQuery(this);
			jQuery.ajax({
				url: jQuery(this).attr('href'),
				method: 'post'
			}).done(function () {
				$link.replaceWith(I18n.t('sent'))
			});
			return false;
		})
		jQuery('.invitation-cancel-link').on('click', function () {
			jQuery.ajax({
				url: jQuery(this).attr('href'),
				method: 'post'
			}).done(function () {
				Turbo.visit(top.location.href);
			});
			return false;
    })

    var userTable = jQuery("#user-table");
    if (userTable.length) {
        var columnNames = userTable.data("column-names");

        var columnDefs = [
            {
              mRender: function(data, type, rowData) {
                if (data.type == 'person') {
                  var links = (data.is_owner ?
                    jQuery('#disabled_delete_btn_template').html() + jQuery('#edit_user_type_btn_template').html() : jQuery('#delete_btn_template').html() + jQuery('#edit_user_type_btn_template').html()).
                    replace(/___id___/g, data.id).
                    replace(/___first_name___/g, data.first_name).
                    replace(/___last_name___/g, data.last_name).
                    replace(/___person_id___/g, data.person_id);

                  return jQuery('<div>').append(links).html();
                }
                else {
                  var resendLink = $('<a>').attr('href', user_management_resend_invitation_path({person_id: data.person_id, project_id: data.project_id})).
                    addClass('btn btn-xs btn-success pull-right invitation-resend-link').html(I18n.t('resend'));
                  var cancelLink = $('<a>').attr('href', user_management_cancel_invitation_path({person_id: data.person_id, project_id: data.project_id})).
                    addClass('btn btn-xs btn-danger pull-right invitation-cancel-link').html(I18n.t('cancel'));

                  return $('<div>').append(cancelLink).html() + $('<div>').append(resendLink).html();
                }
              },
              orderable: false,
              searchable: false,
              // width: '120px',
              aTargets: [columnNames.indexOf("actions")]
            },
            {
                mRender: function(data, type ,rowData){
                    if (type == 'display') {
                        return data.label;
                    }
                    return data.sort;
                },
                aTargets: [columnNames.indexOf("last_login")]
            },
        ];

        if (columnNames.indexOf("fund_user_rights") != -1) {
            columnDefs.push({
              mRender: function (data, type, rowData) {
                return data
                  ? data
                  : jQuery("<div>")
                      .append(jQuery("<span>").addClass("muted").text(I18n.t("inherit_from_fund")))
                      .html();
              },
              aTargets: [columnNames.indexOf("project_user_rights")],
            });
        }

        var options = {
          bDeferRender: true,
          aaData: JSON.parse(jQuery('#list-data').html()),
          info: false,
          lengthChange: false,
		  language: {
			searchPlaceholder: I18n.t('search')
		  },
          pageLength: 20,
          autoWidth: false,
          stateSave: true,
          fnCreatedRow: function( nRow, aData, iDataIndex) {
            jQuery(nRow).attr('class', 'user-row-' + aData[columnNames.indexOf("actions")].id);
          },
          aoColumnDefs: columnDefs,
          initComplete: function() {
            DataTablesHelper.addColumnFilters(this);
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          }
        };

        var userTable = jQuery('#user-table');
        userTable.DataTable(options);
        userTable.data('updateRoleName', function(row, roleName) {
          var row = jQuery('#user-table').DataTable().row(row)
          var data = row.data();
          data[columnNames.indexOf("fund_user_rights") != -1 ? columnNames.indexOf("fund_user_rights") : columnNames.indexOf("project_user_rights")] = roleName;
          row.data(data).draw();
        });
    }

    jQuery('[data-tooltip]').tooltip();

	},

	account_information: function () {
		jQuery('.smartme-toggle').smartmeToggle();
		jQuery('.main.clearfix').css('max-width', 600);

		jQuery('#app-login-token').on('click', function () {
			jQuery(this).find('button').remove();
			jQuery(this).append(SmartME.loadingIndicator(80, {position: 'absolute', 'margin-top': '0px'}));
			jQuery(this).find('svg').css({opacity: 0.3});
			jQuery.get(companion_qr_svg_path(), function(data) {
			  jQuery('#app-login-token').get(0).innerHTML = data.svg;
			}) 
		  }) 
	},

	account_information_edit: function () {
		this.account_information();
	},

	account_information_update: function () {
		this.account_information();
	},

	login_credentials_update: function () {
		this.account_information();
	},

	send_email: function () {
		var updateRecipientCount = function () {
			jQuery('.recipient-count').html(jQuery('.send-email-list input:checked').length);
			updateListView();
		};

		var updateListView = function() {
			if (jQuery("#display-mode").attr("mode") === 'selected') {
				jQuery('.send-email-list li').each(function () {
					if (jQuery(this).find('input')[0]) {
						jQuery(this).css('display', jQuery(this).find('input')[0].checked ? '' : 'none');
					}
				})
			}
			else{
				jQuery('.send-email-list li').css('display','');
			}
		}

		jQuery('a.recipient-select').on('click', function (ev) {
			var link = jQuery(this);
			var linkType = ['all', 'none'].filter(function (e) {
				return link.attr('class').split(' ').indexOf(e) >= 0
			})[0];
			jQuery('.send-email-list input').each(function () {
				jQuery(this).prop('checked', linkType === 'all');
			})
			updateRecipientCount();
		});

		jQuery('a.recipient-display').on('click', function (ev) {
			var link = jQuery(this);
			var linkType = ['selected', 'all'].filter(function (e) {
				return link.attr('class').split(' ').indexOf(e) >= 0
			})[0];
			jQuery("#display-mode").attr("mode",linkType);
			updateListView();
		});

   		jQuery('.send-email-list').on('click', 'input', updateRecipientCount);
		if(jQuery('.send-email-list input:checked').length != 0 ){
			jQuery('a.recipient-display.selected').trigger('click');
		}
	},

	edit_companion_preferences: function(){
		jQuery('.smartme-toggle').smartmeToggle();

		jQuery('#mfa_required').on('click', function () {
			jQuery(this).hasClass("no") ? jQuery(".authentication-info-text").css('display', 'none') : jQuery(".authentication-info-text").css('display', 'block');
		})

		jQuery('#app-login-token').on('click', function () {
			jQuery(this).find('button').remove();
			jQuery(this).append(SmartME.loadingIndicator(80, {position: 'absolute', 'margin-top': '0px'}));
			jQuery(this).find('svg').css({opacity: 0.3});
			jQuery.get(companion_qr_svg_path(), function(data) {
				jQuery('#app-login-token').get(0).innerHTML = data.svg;
			})
		})
	},

    priv: {
      bindEvent: function () {
        initModalDialogs();

        jQuery(document).on('click', '.invitation-resend-link', function () {
            var $link = jQuery(this);
            $link
              .off('click')
              .on('click', function (e) {
                  jQuery.ajax({
                      url: $link.attr('href'),
                      method: 'post'
                  }).done(function () {
                      $link.replaceWith(I18n.t('sent'))
                  });
              });

            return false;
        });

        jQuery(document).on('click', '.invitation-cancel-link', function () {
            var $link = jQuery(this);
            $link
              .off('click')
              .on('click', function (e) {
                  jQuery.ajax({
                      url: $link.attr('href'),
                      method: 'post'
                  }).done(function () {
                      Turbo.visit(top.location.href);
                  });
              });

            return false;
        });

        jQuery(document).on('click', '.user-delete-link', function () {
          jQuery(this)
            .off('click')
            .on('click', function (e) {
                e.stopPropagation();
                var c = true;
                if (jQuery(this).data('confirm')) {
                    c = confirm(jQuery(this).data('confirm'));
                }
                if (c) {
                  jQuery
                    .ajax({
                        url: jQuery(this).attr('href'),
                        method: jQuery(this).attr('data-method'),
                        headers: { 'X-CSRF-Token': jQuery('meta[name="csrf-token"]').attr('content') }
                    })
                    .done(function (d) {
                        Turbo.visit(window.location.href);
                    })
                    .fail(function (e) {
                        alert((((e.responseJSON || {}).id || [])[0] || {}).message || I18n.t('unexpected_error'));
                    });
                }
                e.preventDefault();
            });

          return false;
        });

      }
    }
};
